/* NUYU Editions landing page behaviour: gallery, jump bar, Edition picker. */
(() => {
  // Every Editions section includes this file; only set up once per page.
  if (window.__nedEditionsReady) return;
  window.__nedEditionsReady = true;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Scroll to an in-page anchor, leaving room for the sticky header.
  const jumpTo = (hash) => {
    const el = hash && document.getElementById(hash.replace('#', ''));
    if (!el) return false;
    const header = document.querySelector('sticky-header, .section-header');
    const off = header ? Math.max(0, header.getBoundingClientRect().bottom) + 12 : 12;
    window.scrollTo({ top: el.getBoundingClientRect().top + scrollY - off, behavior: reduce ? 'auto' : 'smooth' });
    history.replaceState(null, '', hash);
    return true;
  };
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href^="#"]');
    if (a && a.closest('.ned') && a.getAttribute('href').length > 1 && jumpTo(a.getAttribute('href'))) e.preventDefault();
  });

  if (!customElements.get('ned-gallery')) {
    customElements.define('ned-gallery', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('.ned-gal__slide')];
        this.thumbs = [...this.querySelectorAll('.ned-gal__thumb')];
        this.cur = 0;
        this.thumbs.forEach((t, i) => t.addEventListener('click', () => this.show(i)));
        const main = this.querySelector('.ned-gal__main');
        let x0 = null, y0 = 0;
        main.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
        main.addEventListener('touchend', (e) => {
          if (x0 === null) return;
          const dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
          x0 = null;
          if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
          this.show((this.cur + (dx < 0 ? 1 : -1) + this.slides.length) % this.slides.length);
        }, { passive: true });
      }
      show(i) {
        this.slides.forEach((s, j) => {
          s.classList.toggle('is-active', j === i);
          const img = s.querySelector('img');
          if (j === i && img && img.loading === 'lazy') img.loading = 'eager';
        });
        this.thumbs.forEach((t, j) => t.setAttribute('aria-pressed', j === i ? 'true' : 'false'));
        this.cur = i;
      }
    });
  }

  if (!customElements.get('ned-jump')) {
    customElements.define('ned-jump', class extends HTMLElement {
      connectedCallback() {
        this.bar = this.querySelector('.ned-jump');
        this.links = [...this.querySelectorAll('.ned-jump a')];
        this.targets = this.links.map((a) => document.getElementById(a.getAttribute('href').slice(1)));
        this.hero = this.closest('.ned-hero');
        this.onScroll = this.onScroll.bind(this);
        addEventListener('scroll', this.onScroll, { passive: true });
        addEventListener('resize', this.onScroll);
        this.onScroll();
      }
      disconnectedCallback() {
        removeEventListener('scroll', this.onScroll);
        removeEventListener('resize', this.onScroll);
      }
      onScroll() {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = null;
          const found = this.targets.filter(Boolean);
          if (!found.length) return;
          const heroGone = this.hero.getBoundingClientRect().bottom < 80;
          const last = found[found.length - 1].getBoundingClientRect();
          const pastLast = last.bottom < innerHeight * 0.35;
          this.bar.classList.toggle('is-on', heroGone && !pastLast);
          const header = document.querySelector('sticky-header, .section-header');
          const top = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
          this.bar.style.setProperty('--ned-jump-top', top + 12 + 'px');
          let active = -1;
          this.targets.forEach((t, i) => { if (t && t.getBoundingClientRect().top < innerHeight * 0.45) active = i; });
          this.links.forEach((a, i) => a.classList.toggle('is-active', i === active));
          const on = this.links[active];
          if (on && this.bar.scrollWidth > this.bar.clientWidth) {
            this.bar.scrollTo({ left: on.offsetLeft - 8, behavior: reduce ? 'auto' : 'smooth' });
          }
        });
      }
    });
  }

  // Dots under the swipeable hero tiles (tablet and phone).
  document.querySelectorAll('[data-tile-dots]').forEach((wrap) => {
    const track = wrap.previousElementSibling;
    const tiles = [...track.querySelectorAll('.ned-tile')];
    const dots = [...wrap.querySelectorAll('.ned-tiles__dot')];
    const mark = (i) => dots.forEach((d, j) => (j === i ? d.setAttribute('aria-current', 'true') : d.removeAttribute('aria-current')));
    let raf;
    track.addEventListener('scroll', () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = null;
        const x = track.scrollLeft + track.clientWidth * 0.3;
        let i = 0;
        tiles.forEach((t, j) => { if (t.offsetLeft - track.offsetLeft <= x) i = j; });
        if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) i = tiles.length - 1;
        mark(i);
      });
    }, { passive: true });
    dots.forEach((d, i) => d.addEventListener('click', () => {
      track.scrollTo({ left: tiles[i].offsetLeft - track.offsetLeft - parseFloat(getComputedStyle(track).paddingLeft || 0), behavior: reduce ? 'auto' : 'smooth' });
      mark(i);
    }));
  });

  // Shadow on the pinned Edition column once the table has scrolled sideways.
  document.querySelectorAll('[data-compare-wrap]').forEach((w) => {
    const on = () => w.classList.toggle('is-scrolled', w.scrollLeft > 4);
    w.addEventListener('scroll', on, { passive: true });
    on();
  });

  // Add to basket without leaving the page when the theme's cart drawer is there;
  // otherwise the form posts normally and Shopify goes to the cart.
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-ned-cart]');
    if (!form) return;
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (!cart || typeof cart.renderContents !== 'function' || typeof cart.getSectionsToRender !== 'function') return;
    e.preventDefault();
    const btn = form.querySelector('button[type="submit"]');
    btn.classList.add('is-loading');
    btn.textContent = btn.dataset.adding || btn.textContent;
    const fd = new FormData(form);
    fd.append('sections', cart.getSectionsToRender().map((s) => s.id));
    fd.append('sections_url', location.pathname);
    try {
      const res = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body: fd,
      }).then((r) => r.json());
      if (res.status) { form.submit(); return; }
      cart.classList.remove('is-empty');
      cart.renderContents(res);
    } catch (_) {
      form.submit();
    } finally {
      btn.classList.remove('is-loading');
      btn.textContent = btn.dataset.label || btn.textContent;
    }
  });

  if (!customElements.get('ned-quiz')) {
    customElements.define('ned-quiz', class extends HTMLElement {
      connectedCallback() {
        this.opts = [...this.querySelectorAll('.ned-quiz__opt')];
        this.res = [...this.querySelectorAll('.ned-quiz__res')];
        this.opts.forEach((o, i) => o.addEventListener('click', () => {
          this.opts.forEach((x, j) => x.setAttribute('aria-pressed', j === i ? 'true' : 'false'));
          this.res.forEach((r, j) => {
            const on = j === i;
            r.classList.toggle('is-active', on);
            r.setAttribute('aria-hidden', on ? 'false' : 'true');
            r.querySelectorAll('a').forEach((a) => (on ? a.removeAttribute('tabindex') : a.setAttribute('tabindex', '-1')));
          });
          if (innerWidth < 990) this.res[i].scrollIntoView({ block: 'nearest', behavior: reduce ? 'auto' : 'smooth' });
        }));
      }
    });
  }
})();
